
import * as React from 'react';

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { Add, AddTask, ArrowBack, BackHand, Remove, RemoveCircle } from '@mui/icons-material';
import { Box, Button, Container, IconButton, Snackbar, Stack, Tooltip, Typography } from '@mui/material';
import Service from '../../../util/Service';
import { formataDataHora } from '../../../util/Utilitarios';


const NodeCallActivity = React.forwardRef((props, ref) => {
    const { item, processo, style } = props;
    const childRef = React.useRef();    

    const [show, setShow] = React.useState(false);
    const [lst, setLst]= React.useState([]);
    const [lstF, setLstF]= React.useState([]);
    const [escolhidos, setEscolhidos] = React.useState([]);
    const [open, setOpen] = React.useState(false);
    const [task, setTask] = React.useState();

    React.useImperativeHandle(ref, () => ({
        childMethod() {
            salva();
        }
    }));
    React.useEffect(() => {
        if (item && processo) {
            const t = processo.lstTask.find((i) => i.idTask === item.id);
            if (t) {
                console.log( t );
                setTask(t);
                if( t.activitys && t.activitys.length > 0){
                    Service.GET("/api/bpmn/buscaTodosAtivos").then(r => {
                        if (r && r.length > 0) {
                            console.log( r );
                            setLst(r);
                            const arr = [];
                            for(let l of r){
                                const item = t.activitys.find(e => e.idProcesso === l.id);
                                if( item )arr.push(l);
                                
                            }
                            setEscolhidos(arr);
                        }
                    }).catch( er =>{
                        console.log( er)
                    });
                }

            }
        }
    }, [])
    React.useEffect(()=>{
        if( show && lst.length === 0 ){
            Service.GET("/api/bpmn/buscaTodosAtivos").then(r => {
                if (r && r.length > 0) {
                    console.log( r );
                    setLst(r);
                    aplicaFiltro(r);
                }
            }).catch( er =>{
                console.log( er)
            });
        }else{
            aplicaFiltro(lst)
        }
    },[show]);


    function salva() {
        const arr = [];
        for(let e of escolhidos ){
            arr.push({
                idProcesso: e.id,
            })
        }
        const dado = {
            idTask: item.id,
            idProcesso: processo.id,            
            taskType: item.type,            
            activitys: arr
        }
        console.log( dado );

        Service.POST("/api/bpmn/salvarTaskDoProcesso", dado).then(resp => {
            setOpen(true);  
        }).catch(error => {
            console.error(error)
        });
    }
    function handleCallOtherActivity() {
        setShow(true);
    }
    function escolhaAction(row){
        const arr = [...escolhidos];
        arr.push( row)
        setEscolhidos(arr);
        setShow(false);
    }
    function remove(row){
        const arr=[];
        for( let e of escolhidos ){
            if(e.id === row.id)continue;
            arr.push(e);
        }
        setEscolhidos(arr);
    }
    function aplicaFiltro(lista){
        const arr = [];
        for(let l of lista){
            const item = escolhidos.find(e => e.id === l.id);
            if( item )continue;

            arr.push(l)
        }
        setLstF(arr);
        console.log('>>>aplicaFiltro<<<', arr);
    }

    function MontaEscolha() {
        if (!show) return;
        return (
            <div spacing={2}>
                <Typography variant='h4' align='center'>Chama outra atividade</Typography>
                <div direction="row" spacing={2} className='pd-float-dir' style={{ position: 'relative', right: 0, top: -40 }}>
                    <Button variant="contained" startIcon={<ArrowBack />} onClick={()=> setShow(false) }>
                        Voltar
                    </Button>
                </div>
                <p>Duplo click para escolher uma atividade</p>
                <TableContainer component={Paper}>
                    <Table sx={{ minWidth: 650 }} size="small" aria-label="a dense table">
                        <TableHead>
                            <TableRow>
                                <TableCell>Pacote</TableCell>
                                <TableCell>Nome</TableCell>
                                <TableCell>Descrição</TableCell>
                                <TableCell align="center">Data Criação</TableCell>
                                <TableCell align="right">Ação</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {lstF.map((row) => (
                                <TableRow
                                    key={row.id}
                                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                >
                                    <TableCell component="th" scope="row">
                                        {row.pacote}
                                    </TableCell>
                                    <TableCell>{row.nome}</TableCell>
                                    <TableCell>{row.descrica}</TableCell>
                                    <TableCell align="center">{formataDataHora(row.data) }</TableCell>
                                    <TableCell align="right">
                                        <Tooltip title="Escolher esse">
                                            <IconButton color="primary" aria-label="add activity" onClick={() => escolhaAction(row)}>
                                                <AddTask />
                                            </IconButton>
                                        </Tooltip>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </div>
        )
    }
    function MontaAtividade() {
        if (show) return;
        return (
            <div>
                <Typography variant='h4' align='center'>Chama outra atividade</Typography>
                <div direction="row" spacing={2} className='pd-float-dir' style={{ position: 'relative', right: 0, top: -40 }}>
                    <Button variant="contained" endIcon={<Add />} onClick={handleCallOtherActivity}>
                        Nova
                    </Button>
                </div>
                <TableContainer component={Paper}>
                    <Table sx={{ minWidth: 650 }} size="small" aria-label="a dense table">
                        <TableHead>
                            <TableRow>
                                <TableCell>Pacote</TableCell>
                                <TableCell>Nome</TableCell>
                                <TableCell>Descrição</TableCell>
                                <TableCell align="center">Data Criação</TableCell>
                                <TableCell align="right">Ação</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {escolhidos.map((row) => (
                                <TableRow
                                    key={row.id}
                                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                >
                                    <TableCell component="th" scope="row">
                                        {row.pacote}
                                    </TableCell>
                                    <TableCell>{row.nome}</TableCell>
                                    <TableCell>{row.descrica}</TableCell>
                                    <TableCell align="center">{formataDataHora(row.data) }</TableCell>
                                    <TableCell align="right">
                                        <Tooltip title="Remover">
                                            <IconButton color="primary" aria-label="add activity" onClick={() => remove(row)}>
                                                <RemoveCircle />
                                            </IconButton>
                                        </Tooltip>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </div>
        )
    }

    return (
        <Container>
            <MontaAtividade />
            <MontaEscolha />
            <Snackbar
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                open={open}
                onClose={() => setOpen(false) }
                message="Salvo com sucesso!"
                />
        </Container>
    )

});

export default NodeCallActivity;